<template>
    <v-container id="update-info-1" class="text-center">

        <v-row>
            <v-col class="hdr">
                <h1 class="other-font">tenpredict</h1>
                <h3>Welcome back!</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                As you can see, we've spruced things up a bit. Hope you like the new site.
            </v-col>
        </v-row>

        <v-row>
            <v-col class="font-lighter">
                Before we continue, please can we take a few more bits of info from you?  Thanks!
            </v-col>
        </v-row>

        <v-row>
            <v-col>

                <div class="input-box pa-5">

                    <v-row>
                        <v-col cols="12">
                            <div>Your username is: <span class="font-lighter" v-text="user.username"></span></div>
                            <div>Your email address is: <span class="font-lighter" v-text="user.email"></span></div>
                        </v-col>
                    </v-row>

                    <v-form ref="form" v-model="formIsValid">

                        <div class="name-box my-4">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                            v-model="firstname"
                                            :rules="fNameRules"
                                            label="First name"
                                            validate-on-blur
                                            @focus="error = null"
                                            required
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field
                                            v-model="surname"
                                            :rules="sNameRules"
                                            label="Surname"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-btn block color="secondary" @click="generateName">Or, Generate Fake Name</v-btn>
                                </v-col>
                            </v-row>

                        </div>

                        <v-row v-for="not in notifications" :key="not.id">
                            <v-col cols="8" class="text-right">
                                <span v-text="not.text"></span>
                            </v-col>
                            <v-col cols="4">
                                <v-radio-group v-model="not.value" row :rules="not.rules">
                                    <v-radio label="Yes" value="1"></v-radio>
                                    <v-radio label="No" value="0"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>

                    </v-form>

                    <v-row class="button-row">
                        <v-col>
                            <v-btn class="float-right" color="secondary" @click="submit">Submit</v-btn>
                        </v-col>
                    </v-row>

                </div>

            </v-col>
        </v-row>


    </v-container>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: "Preferences",
    components: {},
    data () {
      return {
        firstname: '',
        surname: '',
        fNameRules: [
          value => !!value || 'First name is required',
        ],
        sNameRules: [
          value => !!value || 'Surname is required',
        ],
        error: null,
        formIsValid: false,
        notifications: [
          {
            id: 'pref_not_reminder',
            text: 'Send me prediction reminder emails. (Recommended)',
            value: null,
            rules: [
              value => !!value || 'Please select Yes or No',
            ]
          },
          {
            id: 'pref_not_scores_in',
            text: 'Send me an email when the weekend\'s scores are in.',
            value: null,
            rules: [
              value => !!value || 'Please select Yes or No',
            ]
          },
        ]
      }
    },
    computed: {
      ...mapGetters([
        'user',
        'existingFullNames',
        'fnames',
        'snames',
      ]),
      formValid() {
        return this.$refs.form.validate();
      }
    },
    methods: {
      ...mapActions([
        'getNames',
        'updatePrefsFirstLogIn',
      ]),
      generateName() {
        let fullName;
        let fNameIndex;
        let sNameIndex;
        let numFnames = this.fnames.length;
        let numSnames = this.snames.length;
        do {
          fNameIndex = Math.floor(Math.random() * numFnames);
          sNameIndex = Math.floor(Math.random() * numSnames);
          fullName = this.fnames[fNameIndex] + ' ' + this.snames[sNameIndex];
        } while (this.existingFullNames.indexOf(fullName) > -1)
        this.firstname = this.fnames[fNameIndex];
        this.surname = this.snames[sNameIndex];
        this.formIsValid = true;
      },
      submit() {
        if (!this.$refs.form.validate()) {
          return;
        }

        let data = {
          firstname: this.firstname,
          surname: this.surname,
        }

        for (let n = 0; n < this.notifications.length; n++) {
          data[this.notifications[n].id] = this.notifications[n].value
        }

        this.updatePrefsFirstLogIn(data);
      }
    },
    created() {
      this.getNames();
    },
  }
</script>

<style scoped>

    #update-info-1 {
        max-width: 750px;
    }

    .name-box {
        padding: 1.5rem;
        border: 2px solid var(--v-secondary-base);
        background-color: #ffffff;
    }

    .other-font {
        font-family: "Montserrat-Regular";
        color: black;
    }

    .font-lighter {
        font-family: "Barlow-Regular";
    }

    .input-box {
        background-color: #EFEBE9;
        border-radius: 10px;
    }

</style>
